import { Device, DeviceConsumptionResult } from 'types/Device';

export interface GenerateDeviceOpts {
    status?: string;
}

export const generateDevice = (opts?: GenerateDeviceOpts) => {
    const device: Device = {
        name: '',
        address: '',
        // Assign a probs unique id.
        deviceId: Math.floor(Math.random() * 1000000).toString(),
        shortDeviceId: Math.floor(Math.random() * 1000000).toString(),
        accountId: '',
        fuelType: '',
        capacity: 0,
        connection_type: 'wifi',
        status: opts?.status ?? 'deployed',
        consumptionType: {
            bulk_storage: false,
            commercial_industrial: false,
            cooking: false,
            fireplace: false,
            generator: false,
            heating: false,
            hot_water: false,
            laundry_dryer: false,
            pool: false,
            retail_fill_up: false,
            backup_heating: false,
        },
        orientation: 'horizontal',
        customer_name: '',
        platform: '',
        carrier: '',
        product_name: '',
        product_id: '',
        ullage: 0,
        virtual: false,
        lat: 0,
        lng: 0,
        hw_rev: '',
        sw_rev: '',
        deployed_time: 0,
        lastReading: null,
        lastActiveDelivery: null,
        mfg_tla: '',
        battery_crit: 0,
        battery_warn: 0,
        item_number: '',
        l30: '',
        v_15: '',
        t_15: '',
        c_avg_7: 0,
        c_avg_30: 0,
        p_avg_7: 0,
        p_avg_30: 0,
        duf_7: 0,
        es_update_time: 0,
        virtual_supplier: [],
        p_avg_3: 0,
        gallons: 0,
        bo_sync_msg: '',
        bo_sync_time: 0,
        c_avg_3: 0,
        group: null,
        mfg_tla_rev: '',
        hologram_usage: {
            ota_conn_count: 0,
            bytes: 0,
            conn_count: 0,
            ota_byes: null,
        },
        t_int: 0,
        mfg_tla_dev: '',
        bo_delivery_time: null,
        clone_time: null,
        r_int: 0,
        x30: '',
        imei: '',
        hardware_review: null,
        bo_has_open_delivery: null,
        delivery_type: null,
        rsrp_avg: 0,
        lastPrediction: {
            hdd: 0,
            predictions: [],
        },
        std_dev: 0,
        health: {
            icon: '',
            color: '',
            tooltip: '',
        },
        thresh1: 0,
        thresh2: 0,
        tcov: 0,
        status_history: {
            deployed_time: 0,
            deployed_time_iso: '',
        },
        lastReadingTime: '',
        protected: {
            supplierId: 'test',
        },
    };
    return device;
};

export const generateDeviceConsumptionResult = (): DeviceConsumptionResult => {
    const result: DeviceConsumptionResult = {};
    return result;
};
